import { HelpPadTab } from "src/app/services/api-service/hist/help-pad-api";

export enum FocusId{
  None = '',
  /** 特記 */
  SpecialRemark = 'SpecialRemark',
  /** 特記(西醫打字查詢) */
  SpecialNote = 'SpecialNote',
  /** 主訴 */
  CC = 'CC',
  /** 理學 */
  PE = 'PE',
  /** 診斷 */
  Diag = 'Diag',
  /** 醫令 */
  Order = 'Order',
  /** 特記 */
  Remark ='Remark',
  /** 生理量測 */
  VT ='VT',
  /** 望 */
  ChiLook = 'ChiLook',
  /** 問 */
  ChiAsk = 'ChiAsk',
  /** 脈 */
  ChiPulse = 'ChiPulse',
  /** 脈左 */
  ChiPulseLeft = 'ChiPulseLeft',
  /** 脈右 */
  ChiPulseRight = 'ChiPulseRight',
  /** 辯證 */
  ChiBianZheng = 'ChiBianZheng',
  /** 治則 */
  ChiTreatRule = 'ChiTreatRule',
  /** 療效 */
  ChiTreatEffect = 'ChiTreatEffect',
  /** 醫囑 */
  ChiDoctorOrder = 'ChiDoctorOrder',
  /** 藥局病患資料 */
  PharPatient = 'PharPatient',
  /** 藥局掛號資料 */
  PharRegister = 'PharRegister',
}

export var tabOfArea = [
  {Area:FocusId.SpecialRemark, PadTab:HelpPadTab.SpecialRemark},
  {Area:FocusId.SpecialNote, PadTab:HelpPadTab.SpecialNote},
  {Area:FocusId.CC, PadTab:HelpPadTab.CC},
  {Area:FocusId.PE, PadTab:HelpPadTab.PE},
  {Area:FocusId.Diag, PadTab:HelpPadTab.DX},
  {Area:FocusId.Order, PadTab:HelpPadTab.RX},
  // 頻率讓他focus到醫令區好了
  {Area:FocusId.Order, PadTab:HelpPadTab.Freq},
  {Area:FocusId.ChiAsk, PadTab:HelpPadTab.ChiAsk},
  {Area:FocusId.ChiLook, PadTab:HelpPadTab.ChiLook},
  {Area:FocusId.ChiPulse, PadTab:HelpPadTab.ChiPulse},
  {Area:FocusId.ChiPulseLeft, PadTab:HelpPadTab.ChiPulseLeft},
  {Area:FocusId.ChiPulseRight, PadTab:HelpPadTab.ChiPulseRight},
  {Area:FocusId.ChiBianZheng, PadTab:HelpPadTab.ChiBianZheng},
  {Area:FocusId.ChiTreatRule, PadTab:HelpPadTab.ChiTreatRule},
  {Area:FocusId.ChiTreatEffect, PadTab:HelpPadTab.ChiTreatEffect},
  {Area:FocusId.ChiDoctorOrder, PadTab:HelpPadTab.ChiDoctorOrder},

]
